import {
    STAFF_CORRECTION_REQUEST, STAFF_DATA_KPI, STAFF_LIST_CORRECTION, MESSAGE_LIST,
    ALL_CORRECTION_DATA
} from './../actions/ActionTypes';
import InitialState from './InitialState';

const StaffDataReducer = (state = InitialState.staffData, action) => {
    switch (action.type) {
        case STAFF_DATA_KPI: {
            // KPI List
            return {
                ...state,
                staffKPIList: [...action.staffKPIList]
            }
        }
        case STAFF_LIST_CORRECTION: {
            // Staff list with pending correction count
            return {
                ...state,
                userListData: [...action.userListData]
            }
        }
        case STAFF_CORRECTION_REQUEST: {
            return {
                ...state,
                requests: [...action.requests]
            }
        }
        case MESSAGE_LIST: {
            return {
                ...state,
                messages: [...action.msgListData]
            }
        }
        case ALL_CORRECTION_DATA: {
            return {
                ...state,
                correctionDataList: [...action.list]
            }
        }

        default:
            return state;
    }
};

export default StaffDataReducer;



// WEBPACK FOOTER //
// ./src/reducers/StaffDataReducer.js